import * as React from 'react';
import * as IDatabase from '../../../types/database';
import {FormattedMessage, InjectedIntlProps, injectIntl, defineMessages } from 'react-intl';

interface ICreateFieldProps {
    onSave: (field: IDatabase.IField) => Promise<void>;
    modalId: string;
    field?: IDatabase.IField | null;
    sectionName: string;
}
const defaultState = {
    isEdit: false,
    label: '',
    fixed: false,
    name: '',
    type: '',
    options: [''],
    predefined: null,
    isRequired: false,
    selection: '',
    multiLine: false,
    group: '',
    extra: {
        help: '',
        type: ''
    }
};
class CreateField extends React.Component<ICreateFieldProps & InjectedIntlProps, IDatabase.IField> {
    state = { ...defaultState };
    isEdit = false;
    messages = defineMessages({
        yes: {
            id: 'db.create.field.yes',
            defaultMessage: 'Yes'
        },
        no: {
            id: 'db.create.field.no',
            defaultMessage: 'No'
        },
        cancel: {
            id: 'db.create.field.cancel',
            defaultMessage: 'Cancel'
        },
        edit: {
            id: 'db.create.field.edit',
            defaultMessage: 'Edit'
        },
        add: {
            id: 'db.create.field.add',
            defaultMessage: 'Add'
        },
        close: {
            id: 'db.create.field.close',
            defaultMessage: 'Close'
        },
        save: {
            id: 'db.create.field.save',
            defaultMessage: 'Save'
        },
        single: {
            id: 'db.create.field.single',
            defaultMessage: 'Single line'
        },
        multiple: {
            id: 'db.create.field.multiple',
            defaultMessage: 'Multiple lines'
        },
        enterValue: {
            id: 'db.create.field.enterValue',
            defaultMessage: 'Free entry'
        },
        selectValue: {
            id: 'db.create.field.selectValue',
            defaultMessage: 'Select from list'
        }
    });

    componentDidUpdate(prevProps: ICreateFieldProps, prevState: IDatabase.IField) {
        if (!this.props.field && prevProps.field) {
            this.setState(defaultState);
        } else if (this.props.field && prevProps.field !== this.props.field) {
            this.isEdit = true;
            let options = this.props.field.options
            let selection = ''
            let multiLine = false
            if (this.props.field.predefined) selection = this.props.field.type.indexOf('Multi') !== -1 ? 'Multi' : 'Single'
            else multiLine = this.props.field.type.indexOf('Long') !== -1
            if (!Array.isArray(this.props.field.options) || !this.props.field.options.length) options = defaultState.options
            // @ts-ignore
            this.setState({ ...defaultState, ...this.props.field, options, selection, multiLine }, () => console.log(this.state));
        }
    }

    save = async () => {
        await this.props.onSave({
            ...this.state,
            name: this.state.label.toLowerCase().replace(/[\W_]+/g, '_'),
            type: this.state.predefined ? `${this.state.selection} Select` : `${this.state.multiLine ? 'Long' : 'Short'} Text`,
            group: this.props.sectionName
        });
        this.setState({ ...defaultState });
    };

    handleInputChange = (event: any) => {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
        /* tslint:disable */
        const x = {};
        x[name] = value;
        this.setState(x);
        /* tslint:enable */
    };

    handleExtraInputChange = (event: any) => {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
        /* tslint:disable */
        const x = {
            ...this.state.extra
        };
        x[name] = value;
        this.setState({ extra: x });
        /* tslint:enable */
    };

    handleBooleanInputChange = (event: any) => {
        const target = event.target;
        let value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
        if (value === 'yes') value = true;
        else if (value === 'no') value = false;
        else value = null;
        /* tslint:disable */
        const x = {};
        x[name] = value;
        this.setState(x);
        /* tslint:enable */
    };

    handleOptionChange = (event: any) => {
        const target = event.target;
        const index = target.name;
        const options = [...this.state.options];
        options[parseInt(index, 10)] = target.value;
        /* tslint:disable */
        this.setState({ options });
        /* tslint:enable */
    };

    removeOption = (index: number) => {
        const options = [...this.state.options];
        options.splice(index, 1)
        this.setState({ options });
    };

    renderDropdownOption = (item: string, index: number) => {
        const canRemove = index > 0;
        return (
            <div key={`option-${index}`} className={`m-0`}>
                {!index && <label><FormattedMessage id="db.create.field.select.values" defaultMessage="Values" /></label>}
                <div className="d-flex flex-row form-group d-flex align-items-center">
                    <input
                        name={`${index}`}
                        type="text"
                        value={item}
                        autoComplete="off"
                        placeholder={`Option ${index + 1}`}
                        className="form-control"
                        onChange={this.handleOptionChange}
                    />
                    {canRemove && (
                        <a
                            onClick={() => this.removeOption(index)}
                            className="align-middle btn btn-link">
                            <i className="fas fa-times" />
                        </a>
                    )}
                </div>
            </div>
        );
    };

    addDropdownOption = () => {
        const options = [...(this.state.options || [])];
        options.push('');
        this.setState({ options });
    };

    renderDropdownOptions = () => {
        if (this.state.predefined) {
            return (
                <div className="d-flex flex-column">
                    {(this.state.options || []).map(this.renderDropdownOption)}
                    <div className="formrow ">
                        <span onClick={this.addDropdownOption} className="btn btn-link" style={{ paddingLeft: 0 }}>
                            <i className="fas fa-plus" style={{ margin: '0 .5em 0 0' }} /><FormattedMessage id="db.create.field.select.values.add" defaultMessage="Add another value" />
                        </span>
                    </div>
                </div>
            );
        }
        return null;
    };

    renderPredefined = () => {
        return (
            <div className="col">
                <div className="form-group">
                    <label className="mb-3" htmlFor="type">
                        <FormattedMessage id="db.create.field.fixed?" defaultMessage="Will the user enter a value or select from a list of pre-defined values?" />
                    </label>
                    <select
                        name="predefined"
                        value={
                            this.state.predefined
                                ? 'yes'
                                : this.state.predefined === false
                                    ? 'no'
                                    : ''
                        }
                        onChange={this.handleBooleanInputChange}
                        className="form-control custom-select">
                        <option key="predefnil" value="" />
                        <option key="predefyes" value="yes">{this.props.intl.formatMessage(this.messages.selectValue)}</option>
                        <option key="predefno" value="no">{this.props.intl.formatMessage(this.messages.enterValue)}</option>
                    </select>
                </div>
            </div>
        )
    };

    renderMulti = () => {
        if (this.state.predefined === null) {
            return null
        }
        if (this.state.predefined === false) {
            return (
                <div className="col">
                    <div className="form-group">
                        <label className="mb-3">
                            <FormattedMessage id="db.create.field.text.multi?" defaultMessage="Is this a short text (single line) or longer text (multiple lines or paragraph)?" />
                        </label>
                        <div className="form-check form-check-inline">
                            <input
                                className="form-check-input"
                                id="multiLine-no"
                                name="multiLine"
                                type="radio"
                                value="no"
                                onChange={this.handleBooleanInputChange}
                                checked={!this.state.multiLine}
                            />
                            <label
                                className="form-check-label mr-2"
                                htmlFor="multiLine-no">
                                {this.props.intl.formatMessage(this.messages.single)}
                            </label>
                            <input
                                className="form-check-input ml-4"
                                name="multiLine"
                                type="radio"
                                id="multiLine-yes"
                                value="yes"
                                onChange={this.handleBooleanInputChange}
                                checked={this.state.multiLine}
                            />
                            <label
                                className="form-check-label ml-1"
                                htmlFor="multiLine-yes">
                                {this.props.intl.formatMessage(this.messages.multiple)}
                            </label>
                        </div>
                    </div>
                </div>
            )
        }
        return (
            <div className="col">
                <div className="form-group">
                    <label className="mb-3" htmlFor="type">
                        <FormattedMessage id="db.create.field.select.type" defaultMessage="How many items can be selected?" />
                    </label>
                    <select
                        name="selection"
                        value={this.state.selection}
                        onChange={this.handleInputChange}
                        className="form-control custom-select">
                        <option key="fieldNumNil" value="" />
                        <FormattedMessage id="db.create.field.select.single" defaultMessage="Single">
                            {(txt) => (<option key="fieldSingle" value="Single">{txt}</option>)}
                        </FormattedMessage>
                        <FormattedMessage id="db.create.field.select.multi" defaultMessage="Multiple">
                            {(txt) => (<option key="fieldMulti" value="Multi">{txt}</option>)}
                        </FormattedMessage>
                    </select>
                </div>
            </div>
        )
    };


    render() {
        const { modalId } = this.props;
        return (
            <div
                className="modal fade"
                id={modalId}
                role="dialog"
                aria-labelledby="createFieldModal"
                aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered modal-lg" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <FormattedMessage id="db.create.field.modal.hdr"
                                defaultMessage="{op} Custom Field" values={
                                    this.isEdit ?
                                        { op: this.props.intl.formatMessage(this.messages.edit) } :
                                        { op: this.props.intl.formatMessage(this.messages.add) }
                                }>
                                {(txt) => (<h5 className="modal-title">{txt}</h5>)}
                            </FormattedMessage>
                            <button
                                type="button"
                                className="close"
                                data-dismiss="modal"
                                aria-label={this.props.intl.formatMessage(this.messages.close)}>
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <form>
                                <div className="row">
                                    {this.renderPredefined()}
                                    {this.renderMulti()}
                                </div>
                                <div className="row">
                                    <div className="col">
                                        <div className="form-group">
                                            <label htmlFor="name"><FormattedMessage id="db.create.field.name" defaultMessage="Name" /></label>
                                            <input
                                                name="label"
                                                type="text"
                                                value={this.state.label}
                                                onChange={this.handleInputChange}
                                                className="form-control"
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col">
                                        <div className="form-group">
                                            <label htmlFor="name"><FormattedMessage id="db.create.field.help" defaultMessage="Help Text" /></label>
                                            <textarea
                                                name="help"
                                                value={(this.state.extra && this.state.extra.help) || ''}
                                                onChange={this.handleExtraInputChange}
                                                className="form-control"
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col">{this.renderDropdownOptions()}</div>
                                </div>
                                <div className="row">
                                    <div className="col">
                                        <div className="form-group">
                                            <label><FormattedMessage id="db.create.field.fieldType" defaultMessage="Field Type" /></label>
                                            <select
                                                name="type"
                                                value={(this.state.extra && this.state.extra.type) || ''}
                                                onChange={this.handleExtraInputChange}
                                                className="form-control custom-select"
                                            >
                                                <option value="" />
                                                <option value="title">Title</option>
                                                <option value="contact">Contact Full Name</option>
                                                <option value="contactFirst">Contact First Name</option>
                                                <option value="contactLast">Contact Last Name</option>
                                                <option value="description">Description</option>
                                                <option value="number">Phone Number</option>
                                                <option value="email">Email</option>
                                                <option value="map">Map</option>
                                                <option value="street">Street Address</option>
                                                <option value="city">City</option>
                                                <option value="state">State</option>
                                                <option value="zip">Zip Code</option>
                                                <option value="link">Link</option>
                                                <option value="agesServed">Ages Served</option>
                                                <option value="fees">Fees</option>
                                                <option value="focusArea">Program Focus Area</option>
                                                <option value="availableVirtually">Program available virtually</option>
                                                <option value="gradesServed">Grades served</option>
                                                <option value="servesSpecialNeeds">Serves Special Needs?</option>
                                                <option value="programAvailability">Program Availability</option>
                                                <option value="transportationAvailable">Transportation Available?</option>
                                                <option value="mealsProvided">Meals Provided?</option>
                                                <option value="programDates">Program Dates</option>
                                                <option value="programDaysOfWeek">Program Days of the Week</option>
                                                <option value="programTimes">Program Times</option>
                                                <option value="regular">Regular Field</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col">
                                        <div className="form-group">
                                            <div><FormattedMessage id="db.create.field.required?" defaultMessage="Is this field required?" /></div>
                                            <div className="form-check form-check-inline">
                                                <input
                                                    className="form-check-input"
                                                    name="isRequired"
                                                    type="radio"
                                                    id="required-yes"
                                                    value="yes"
                                                    onChange={this.handleBooleanInputChange}
                                                    checked={this.state.isRequired}
                                                />
                                                <label
                                                    className="form-check-label ml-1"
                                                    htmlFor="required-yes">
                                                    {this.props.intl.formatMessage(this.messages.yes)}
                                                </label>
                                                <input
                                                    className="form-check-input ml-4"
                                                    id="required-no"
                                                    name="isRequired"
                                                    type="radio"
                                                    value="no"
                                                    onChange={this.handleBooleanInputChange}
                                                    checked={!this.state.isRequired}
                                                />
                                                <label
                                                    className="form-check-label"
                                                    htmlFor="required-no">
                                                    {this.props.intl.formatMessage(this.messages.no)}
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                        <div className="modal-footer">
                            <button onClick={this.save} className="primary" data-dismiss="modal">
                                {
                                    this.isEdit ?
                                        this.props.intl.formatMessage(this.messages.save) :
                                        this.props.intl.formatMessage(this.messages.add)
                                }
                            </button>
                            <button className="btn btn-link" data-dismiss="modal">
                                {this.props.intl.formatMessage(this.messages.cancel)}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
export default injectIntl(CreateField);


// WEBPACK FOOTER //
// ./src/client/database/setup/CreateField.tsx